<template>
  <div class="InfoModal">
    <div class="InfoModal__close" @click="close()">
      <svgicon
        class="icon-close"
        icon="icon-close"
        width="14"
        height="14"
      ></svgicon>
    </div>
    <div class="container">
      <div class="InfoModal__row">
        <img :src="`${baseUrl}images/svg/proporziona.svg`" />
        <div class="InfoModal__row__details">
          <div class="title">{{ content.filter.modal.proporziona.label }}</div>
          <div class="paragraph" v-html="content.filter.modal.proporziona.text">
   
          </div>
        </div>
      </div>
      <div class="InfoModal__row">
        <img :src="`${baseUrl}images/svg/normalizza.svg`" />
        <div class="InfoModal__row__details">
          <div class="title">{{ content.filter.modal.normalize.label }}</div>
          <div class="paragraph"  v-html="content.filter.modal.normalize.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/compiled-icons/icon-close";

export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    close() {
      this.$emit("closeModal");
    }
  },
  computed: {
    content() {
      return this.$ml.get("dataviz");
    }
  }
};
</script>
<style lang="scss" scoped>
.InfoModal {
  height: 100vh;
  width: 100vw;
  background-color: $black-80;
  position: fixed;
  z-index: 10000;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  &__close {
    background-color: $white;
    height: 40px;
    position: fixed;
    left: calc(100% - 55px);
    top: 15px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: $z-c;
    cursor: pointer;
    .icon-close {
      fill: $black;
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    max-width: 50%;
  }
  &__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 0;
    &__details {
      display: flex;
      flex-direction: column;
      margin-left: 50px;
      .title {
        @include overlayM;
        color: $white;
        text-transform: uppercase;
        margin-bottom: 10px;
      }
      .paragraph {
        @include pM;
        color: $white;
      }
    }
  }
}
</style>